/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetUsersProfile200, GetUsersProfile400, GetUsersProfileQueryResponse } from '../entities/GetUsersProfile'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { getUserProfileResponseSchema } from './getUserProfileResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getUsersProfile200Schema = z.lazy(() => getUserProfileResponseSchema) as unknown as ToZod<GetUsersProfile200>

/**
 * @description Bad Request
 */
export const getUsersProfile400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetUsersProfile400>

export const getUsersProfileQueryResponseSchema = z.lazy(() => getUsersProfile200Schema) as unknown as ToZod<GetUsersProfileQueryResponse>